import { normalizeCommentParentId } from "../../../../api/noteDocument/noteDocument";

export const isFarmGateSaved = (farmGateId?: string | null): boolean => {
  return Boolean(normalizeCommentParentId(farmGateId));
};
